<template>
    <div>
        <h1 class="h2 mt-4 text-center">{{ mainTitle }}</h1>
        <h2 class="h3 mb-4 text-center">Comment souhaitez-vous que nous gérions votre courrier, {{ services.domiciliation.particulars.name.firstName }} ?</h2>
        <p class="text-center text-black-50">Votre courrier est <b>entre de bonnes mains</b> avec {{ appName }}</p>

        <b-form>
            <OptionCheckbox
            v-for="(option, index) in services.domiciliation.mailOptions"
            :key="index"
            :index="index"
            :option="option"
            @checkboxChange="commitOptions" />
        </b-form>
  </div>
</template>

<script>
    import { mapState } from 'vuex'

    import OptionCheckbox from '../OptionCheckbox.vue'

    export default {
        components: {
            OptionCheckbox
        },
        data() {
            return {
                mainTitle: "Gestion de votre courrier"
            };
        },
        methods: {
            commitOptions(lastOptionClicked) {
                this.$store.commit('updateMail', { lastOptionClicked: lastOptionClicked })
            }
        },
        computed: {
            ...mapState(['appName', 'services'])
        }
    };
</script>
